export const TARGETS = {
  ARTICLES: 'articles'
};

export const DEFAULT_STATE = {
  articles: []
};
